
/* Parans 收藏(Wishlist)统一逻辑 —— 全站加载
   1) 所有 Paran 心形(.pna__fav / .pbs__fav / .pcol__fav / 分类大菜单 fav / [data-paran-fav])
      点击即写入 localStorage['wishlistItem'](与主题原生 wish-list 共用同一 key,互通)。
   2) 刷新后按存储状态恢复 aria-pressed(填充态)。
   3) <paran-wishlist> 自定义元素:读取 handle → AJAX 渲染 Paran 风格卡片 → X 删除 / 取消收藏即移除。
   说明:首页 BS/NA、集合页原先各自只做视觉切换的 fav 监听已移除,统一由此文件代理。 */
(function () {
  "use strict";

  var KEY = "wishlistItem";
  var FAV_SEL =
    ".pna__fav,.pbs__fav,.pcol__fav,.parans-category-header__mega-fav,[data-paran-fav]";

  function read() {
    try {
      var a = JSON.parse(localStorage.getItem(KEY));
      return Array.isArray(a) ? a : [];
    } catch (e) {
      return [];
    }
  }
  function write(a) {
    try {
      localStorage.setItem(KEY, JSON.stringify(a));
    } catch (e) {}
  }
  function has(h) {
    return read().indexOf(h) > -1;
  }
  function add(h) {
    var a = read();
    if (a.indexOf(h) < 0) {
      a.push(h);
      write(a);
    }
  }
  function remove(h) {
    var a = read();
    var i = a.indexOf(h);
    if (i > -1) {
      a.splice(i, 1);
      write(a);
    }
  }
  function toggle(h) {
    if (has(h)) {
      remove(h);
      return false;
    }
    add(h);
    return true;
  }
  function count() {
    return read().length;
  }

  function setAllForHandle(h) {
    var pressed = has(h) ? "true" : "false";
    document.querySelectorAll(FAV_SEL).forEach(function (b) {
      if (b.getAttribute("data-wishlist-handle") === h) {
        b.setAttribute("aria-pressed", pressed);
      }
    });
  }
  function syncAll(root) {
    (root || document).querySelectorAll(FAV_SEL).forEach(function (b) {
      var h = b.getAttribute("data-wishlist-handle");
      if (h) b.setAttribute("aria-pressed", has(h) ? "true" : "false");
    });
  }
  function updateCount() {
    var c = count();
    document.querySelectorAll("[data-wishlist-count]").forEach(function (e) {
      e.textContent = c;
    });
    document
      .querySelectorAll(".wishlist-count-bubble,[data-wishlist-count-bubble]")
      .forEach(function (b) {
        b.style.display = c > 0 ? "" : "none";
        if (b.hasAttribute("data-wishlist-count-bubble")) b.textContent = c;
      });
  }

  /* 全站委托:任何 Paran 心形被点 */
  document.addEventListener("click", function (e) {
    var btn = e.target.closest(FAV_SEL);
    if (!btn) return;
    var h = btn.getAttribute("data-wishlist-handle");
    if (!h) return;
    e.preventDefault();
    e.stopPropagation();
    var added = toggle(h);
    setAllForHandle(h);
    updateCount();
    var id = btn.getAttribute("data-product-id");
    document.dispatchEvent(
      new CustomEvent(added ? "add:wishlist-item" : "remove:wishlist-item", {
        detail: { handle: h, productId: id },
        bubbles: true,
      })
    );
    document.dispatchEvent(new CustomEvent("update:pagination", { bubbles: true }));
    document.dispatchEvent(new CustomEvent("update:wishlist-mail", { bubbles: true }));
    document.dispatchEvent(
      new CustomEvent("paran:wishlist-changed", {
        detail: { handle: h, added: added },
        bubbles: true,
      })
    );
  });

  function init() {
    syncAll();
    updateCount();
  }
  if (document.readyState !== "loading") init();
  else document.addEventListener("DOMContentLoaded", init);

  window.ParanWishlist = {
    read: read,
    has: has,
    add: add,
    remove: remove,
    toggle: toggle,
    count: count,
    sync: syncAll,
    updateCount: updateCount,
  };

  function shopRoot() {
    var base =
      (window.Shopify && Shopify.routes && Shopify.routes.root) || "/";
    if (base.charAt(base.length - 1) !== "/") base += "/";
    return base;
  }

  /* ===== 收藏页渲染元素 ===== */
  if (!customElements.get("paran-wishlist")) {
    customElements.define(
      "paran-wishlist",
      class extends HTMLElement {
        connectedCallback() {
          this.grid = this.querySelector("[data-pwl-grid]");
          this.empty = this.querySelector("[data-pwl-empty]");
          this.moreWrap = this.querySelector("[data-pwl-more-wrap]");
          this.guestNote = this.querySelector("[data-pwl-guest-note]");
          this.viewParam = this.getAttribute("data-view") || "pwish";
          this.MOBILE_BATCH = 8;        /* 移动端默认显示 8 个(4 行 × 2),同 PLP */
          this.shown = this.MOBILE_BATCH;
          this.render();
          this.addEventListener("click", this.onClick.bind(this));
          document.addEventListener(
            "paran:wishlist-changed",
            this.onExternalChange.bind(this)
          );
          var self = this;
          window.addEventListener("resize", function () {
            self.applyMobile();
          });
        }

        isMobile() {
          return window.matchMedia("(max-width: 749px)").matches;
        }

        /* 移动端:超出当前批次(shown)的卡片加 .pwl__card--m-hidden 收起;
           还有更多没显示时显示「加载更多」按钮。桌面端全显示、按钮永远隐藏。 */
        applyMobile() {
          if (!this.grid) return;
          var cards = this.grid.querySelectorAll(":scope > .pwl__card");
          var mobile = this.isMobile();
          for (var i = 0; i < cards.length; i++) {
            cards[i].classList.toggle(
              "pwl__card--m-hidden",
              mobile && i >= this.shown
            );
          }
          if (this.moreWrap) {
            this.moreWrap.hidden = !(mobile && cards.length > this.shown);
          }
        }

        async render() {
          var handles = read();
          if (this.grid) this.grid.innerHTML = "";
          if (!handles.length) {
            this.showEmpty(true);
            return;
          }
          this.showEmpty(false);
          var base = shopRoot();
          for (var i = 0; i < handles.length; i++) {
            try {
              var res = await fetch(
                base + "products/" + handles[i] + "?view=" + this.viewParam
              );
              if (!res.ok) continue;
              var html = await res.text();
              var doc = new DOMParser().parseFromString(html, "text/html");
              var card = doc.querySelector("[data-pwl-card]");
              if (card) this.grid.appendChild(card);
            } catch (e) {}
          }
          if (this.grid && !this.grid.children.length) this.showEmpty(true);
          this.shown = this.MOBILE_BATCH;   /* 渲染完成后重置批次并按设备分批 */
          this.applyMobile();
        }

        showEmpty(on) {
          if (this.empty) this.empty.hidden = !on;
          if (this.grid) this.grid.hidden = on;
          if (this.guestNote) this.guestNote.hidden = on;
        }

        onClick(e) {
          var rm = e.target.closest("[data-pwl-remove]");
          if (rm) {
            e.preventDefault();
            var card = rm.closest("[data-pwl-card]");
            var h = card && card.getAttribute("data-wishlist-handle");
            if (h) {
              remove(h);
              setAllForHandle(h);
              updateCount();
              document.dispatchEvent(
                new CustomEvent("remove:wishlist-item", {
                  detail: { handle: h },
                  bubbles: true,
                })
              );
            }
            if (card) card.remove();
            if (this.grid && !this.grid.children.length) this.showEmpty(true);
            this.applyMobile();   /* 删除后重算移动端分批/按钮 */
            return;
          }
          var more = e.target.closest("[data-pwl-more]");
          if (more) {
            e.preventDefault();
            this.shown += this.MOBILE_BATCH;   /* 再展开 8 个 */
            this.applyMobile();
            return;
          }
          var addBtn = e.target.closest("[data-pwl-add]");
          if (addBtn) {
            e.preventDefault();
            this.addToCart(addBtn);
          }
          /* 心形(.pwl__fav[data-paran-fav])由全站委托处理:取消收藏后 onExternalChange 移除卡片 */
        }

        onExternalChange(e) {
          if (e.detail && e.detail.added === false && this.grid) {
            var c = this.grid.querySelector(
              '[data-wishlist-handle="' + e.detail.handle + '"]'
            );
            if (c) c.remove();
            if (!this.grid.children.length) this.showEmpty(true);
            this.applyMobile();   /* 外部取消收藏移除卡片后重算 */
          }
        }

        async addToCart(btn) {
          var id = btn.getAttribute("data-variant-id");
          if (!id) return;
          var orig = btn.getAttribute("data-label") || btn.textContent;
          btn.setAttribute("data-label", orig);
          btn.disabled = true;

          /* 复用主题 cart-drawer 的刷新机制(同 parans-quality-savings.js):
             带 sections 请求 → renderContents 刷新抽屉+角标 → open 打开抽屉,
             否则之前只 POST、不刷新 UI,看起来「没加入」。 */
          var cartDrawer = document.querySelector("cart-drawer");
          var sections = [];
          if (cartDrawer && typeof cartDrawer.getSectionsToRender === "function") {
            try {
              sections = cartDrawer.getSectionsToRender().map(function (s) { return s.id; });
            } catch (e) { sections = []; }
          }
          var payload = { items: [{ id: Number(id), quantity: 1 }] };
          if (sections.length) {
            payload.sections = sections.join(",");
            payload.sections_url = window.location.pathname;
          }
          var cartAddUrl =
            (window.routes && window.routes.cart_add_url) || shopRoot() + "cart/add.js";

          try {
            var res = await fetch(cartAddUrl, {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
                Accept: "application/javascript",
                "X-Requested-With": "XMLHttpRequest",
              },
              body: JSON.stringify(payload),
            });
            var data = await res.json();
            if (res.ok && !data.status) {
              btn.textContent = "Added ✓";
              if (cartDrawer && typeof cartDrawer.renderContents === "function") {
                try { cartDrawer.renderContents(data); } catch (e) {}
                if (typeof cartDrawer.open === "function") {
                  try { cartDrawer.open(); } catch (e) {}
                }
              } else if (typeof window.publish === "function" && window.PUB_SUB_EVENTS) {
                window.publish(window.PUB_SUB_EVENTS.cartUpdate, {
                  source: "parans-wishlist",
                  cartData: data,
                });
              }
              this.refreshCart();
            } else {
              btn.textContent = orig;
            }
          } catch (e) {
            btn.textContent = orig;
          }
          setTimeout(function () {
            btn.disabled = false;
            btn.textContent = orig;
          }, 1500);
        }

        async refreshCart() {
          try {
            var r = await fetch(shopRoot() + "cart.js");
            var c = await r.json();
            /* parans header 角标:数字直接在 .cart-count-bubble 上(无 span 子元素);
               有就更新文本、确保可见(数量>0)。无则不强建(下次刷新页面会带出)。 */
            document
              .querySelectorAll("[data-cart-count],.cart-count")
              .forEach(function (e) { e.textContent = c.item_count; });
            document
              .querySelectorAll(".cart-count-bubble")
              .forEach(function (b) {
                var span = b.querySelector("span");
                if (span) span.textContent = c.item_count;
                else b.textContent = c.item_count;
                if (c.item_count > 0) b.style.display = "";
              });
            document.dispatchEvent(new CustomEvent("cart:refresh", { bubbles: true }));
          } catch (e) {}
        }
      }
    );
  }
})();
